module.exports = __webpack_public_path__ + "static/media/somos.b2dafaac.png";